import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProductImageCard from '../../../components_common/ProductImageCard';
import { ImageWrapper } from './RelatedProducts.css';
import VerticalSpacer from '../../../components_common/VerticalSpacer/VerticalSpacer';
import ProductListProductInfo from '../../../components_common/ProductInfoCard/ProductListProductInfo';
import productInfoDataSanitizer from '../../../components_common/ProductInfoCard/productInfoDataSanitizer';

// TODO: refactor in functional component
class RelatedProductLink extends Component {
  render() {
    const { currencySymbol, showSale, product, s3BasePath } = this.props;
    return (
      <a
        href={product.url}
        id={`rp-${product.product_id}`}
        data-cy="single-product-related"
        key={`related_p_${product.product_id}`}
        style={{ textDecoration: 'none' }}
      >
        <ImageWrapper>
          <ProductImageCard cart images={product.images} padTop="0" s3BasePath={s3BasePath} product={product} />
        </ImageWrapper>
        <VerticalSpacer height="14px" />
        <ProductListProductInfo
          currencySymbol={currencySymbol}
          product={productInfoDataSanitizer(product)}
          showSale={showSale}
          width="172px"
        />
      </a>
    );
  }
}

RelatedProductLink.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  product: PropTypes.array.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  showSale: PropTypes.bool,
};

export default RelatedProductLink;
